import { Injectable } from '@angular/core';
import { Permissions, TokenResponse } from '@model/auth';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private permissions: Permissions | null = null;

  constructor() { }

  setTokenResponse(token: TokenResponse) {
    this.permissions = {
      admin: token.admin,
    }
  }

  clear() {
    this.permissions = null;
  }

  get admin(): boolean | null {
    return this.permissions ? this.permissions.admin : null;
  }
}
